var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { AppsSection } from "../apps-section";
import { BusinessHeader } from "../apps-section/apps-section-headers/business.apps-section-header";
import { RegularHeader } from "../apps-section/apps-section-headers/regular.apps-section-header";
import { CompleteSetupHeader } from "../apps-section/apps-section-headers/complete-setup.apps-section-header";
import { withTranslation } from "../../component-decorators/with-translation";
import { fetchAppIdsByTag, fetchBundleApps, fetchInstalledApps, fetchSiteData, getAllEmbeddedScriptAppsStatus, getFreeTrialAppIds, getPermittedActions, newDeleteApp, setEmbeddedScriptAppActive, } from "../../api";
import webBiLogger from "@wix/web-bi-logger";
import { appMarketOpenManageApps, manageAppsAddApp, } from "@wix/bi-logger-app-market-data/v2";
import { ModalNames, ModalsNew } from "../modals/modals";
import { EmptyState } from "../empty-state";
import s from "./manage-installed-apps-page.scss";
import { ChevronRight } from "@wix/wix-ui-icons-common";
import { Box, Button, Divider, Heading, Loader, Page, TextButton, WixDesignSystemProvider, } from "@wix/design-system";
import { RecommendedApps } from "../empty-state/recommended-apps";
import { withExperiments } from "../../component-decorators/with-experiments";
import { PermissionsCtx } from "../permissions-context/permissions-ctx";
import { MarketingIntegrationsToast } from "../modals/marketing-integrations-toast/marketing-integrations-toast";
import { getBuilderComps, isBusinessApp, isEmbeddedScriptApp, isMLApp, isNewVersionAvailable, isRegularApp, newAppHasEditor, } from "../../utils/appUtils";
import { enrichBenefitApp, getCompleteSetupApps, getDeepLink, newEnrichBundleApps, } from "../../utils/utils";
import { AppGroup } from "@wix/ambassador-devcenter-managedapps-v1-managed-app/types";
import { ModuleRegistry } from "react-module-container";
import { HttpClient } from "@wix/http-client";
import { AppMarketSaleBanner } from "../app-market-sale-banner";
import { getBenefitApps } from "../../api/benefit-apps-api";
export var Origin;
(function (Origin) {
    Origin["BIZMGR"] = "bizmgr";
    Origin["EDITOR"] = "editor";
    Origin["DAYFUL"] = "dayful";
})(Origin || (Origin = {}));
export var embeddedScriptAppStatus;
(function (embeddedScriptAppStatus) {
    embeddedScriptAppStatus["ENABLED"] = "enabled";
    embeddedScriptAppStatus["DISABLED"] = "disabled";
    embeddedScriptAppStatus["MISSING"] = "missing";
    embeddedScriptAppStatus["NO_STATUS"] = "noStatus";
})(embeddedScriptAppStatus || (embeddedScriptAppStatus = {}));
export var EditorType;
(function (EditorType) {
    EditorType["EDITOR"] = "EDITOR";
    EditorType["EDITORX"] = "EDITORX";
    EditorType["ADI"] = "ADI";
    EditorType["STUDIO"] = "STUDIO";
})(EditorType || (EditorType = {}));
let ManageInstalledAppsPage = class ManageInstalledAppsPage extends React.Component {
    constructor(props) {
        super(props);
        this.httpClient = new HttpClient({
            getAppToken: () => this.props.getAppInstance(this.state.msAppId),
        });
        this.closeModal = async () => {
            if (this.state.modalProps.openModalName === ModalNames.APP_SETTINGS) {
                this.fetchEmbeddedScriptAppsStatusNew(this.state.newInstalledApps).then((data) => this.setState({ embeddedScriptAppsStatus: data }));
            }
            this.setState({
                openModal: ModalNames.NONE,
                modalProps: { openModalName: ModalNames.NONE },
            });
        };
        this.openModal = (modalName, modalProps) => {
            const authorizationHeader = this.props.getAppInstance
                ? this.props.getAppInstance(this.state.msAppId)
                : "";
            const fullModalProps = {
                editorType: this.props.editorType,
                isEditorless: this.props.isEditorless,
                openModalName: modalName,
                closeModal: this.closeModal,
                baseUrl: this.props.baseUrl,
                authorizationHeader,
                origin: this.props.origin,
                editorUrl: this.props.editorUrl,
                manageAppsStaticsUrl: this.props.manageAppsStaticsUrl,
                deleteApp: this.deleteAppAndUpdatePage,
                locale: this.props.locale,
                msId: this.props.metasiteId,
                showUserActionNotification: this.props.showUserActionNotification,
                openDeleteModalAppInEditor: this.props.openDeleteModalAppInEditor,
                openCompleteUpdateInEditor: this.props.openCompleteUpdateInEditor,
                ...modalProps,
            };
            this.setState({
                openModal: modalProps.openModalName,
                modalProps: fullModalProps,
            });
        };
        this.deleteAppByType = async (baseUrl, appToDelete, editorType) => {
            // there used to be an !(isPendingApp(appToDelete)) checkup to the condition as well that was removed
            if ((isMLApp(appToDelete.appId) ||
                (newAppHasEditor(appToDelete) &&
                    !this.props.isEditorless &&
                    editorType !== EditorType.ADI)) &&
                this.props.origin === Origin.EDITOR) {
                return this.props.unInstallApp(appToDelete.appId).then(() => {
                    if (isEmbeddedScriptApp(appToDelete)) {
                        return newDeleteApp(baseUrl, this.httpClient, appToDelete.appId);
                    }
                });
            }
            return newDeleteApp(baseUrl, this.httpClient, appToDelete.appId);
        };
        this.deleteAppAndUpdatePage = (appToDelete, showNotification) => {
            const { baseUrl, locale, editorType, hideBusinessSolutions, origin } = this.props;
            const geoString = "";
            this.deleteAppByType(baseUrl, appToDelete, editorType)
                .then(async () => {
                const isDayfulFlow = origin === Origin.DAYFUL;
                let [installedApps, bundleApps, benefitApps, dayfulApps] = await Promise.all([
                    fetchInstalledApps(baseUrl, this.httpClient, locale, hideBusinessSolutions),
                    fetchBundleApps(baseUrl, this.httpClient, locale, geoString, this.props.experiments),
                    getBenefitApps(this.httpClient, locale, this.props.experiments),
                    isDayfulFlow
                        ? fetchAppIdsByTag(baseUrl, this.httpClient, locale, "e5c806a3-7ef7-4d32-bdc1-bbe913d93d48")
                        : [],
                ]);
                if (origin === Origin.DAYFUL) {
                    installedApps = installedApps.filter((installedApp) => {
                        return dayfulApps.tagApps.some((tagApp) => tagApp.appId === installedApp.appId);
                    });
                }
                const enrichedBenefitApps = benefitApps.map((benefitApp) => enrichBenefitApp(benefitApp, installedApps));
                const enrichedBundleApps = newEnrichBundleApps(bundleApps, installedApps);
                if (showNotification) {
                    const appName = appToDelete?.appInfo?.name;
                    this.props.showUserActionNotification({
                        message: this.props
                            .t("manage-apps.delete-modal.deletion-notification", { appName })
                            .replace("&amp;", "&"),
                        biName: "delete-app",
                        type: "SUCCESS",
                    });
                }
                this.setState({
                    benefitApps: enrichedBenefitApps,
                    newInstalledApps: installedApps,
                    bundleApps: enrichedBundleApps,
                });
            })
                .catch((e) => {
                if (showNotification) {
                    const appName = appToDelete?.appInfo?.name;
                    this.props.showUserActionNotification({
                        message: this.props
                            .t("manage-apps.delete-modal.deletion-error", { appName })
                            .replace("&amp;", "&"),
                        biName: "delete-app",
                        type: "ERROR",
                        action: {
                            text: this.props.t("manage-apps.delete-modal.deletion-error-cta"),
                            uiType: "link",
                            navigationTarget: {
                                url: this.props.t("manage-apps.delete-modal.deletion-error-link"),
                            },
                        },
                        link: {
                            caption: this.props.t("manage-apps.delete-modal.deletion-error-cta"),
                            onNotificationLinkClick: () => {
                                if (window) {
                                    window.open(this.props.t("manage-apps.delete-modal.deletion-error-link"));
                                }
                            },
                        },
                    });
                }
            });
        };
        this.updateEmbeddedScriptAppsStatus = (appDefId, newStatus, appInstanceId) => {
            const isDisabled = newStatus === embeddedScriptAppStatus.DISABLED;
            this.handleEmbeddedScriptToggle(appDefId, isDisabled, appInstanceId, this.state.embeddedScriptAppsStatus)
                .then((res) => {
                const status = { ...this.state.embeddedScriptAppsStatus };
                // @ts-expect-error
                const appStatus = res.status;
                // @ts-expect-error
                const newParameters = res.parameters;
                const newStatusEnum = appStatus === "disabled"
                    ? embeddedScriptAppStatus.DISABLED
                    : embeddedScriptAppStatus.ENABLED;
                status[appDefId] = {
                    status: newStatusEnum,
                    parameters: newParameters,
                };
                this.setState({ embeddedScriptAppsStatus: status });
            })
                .catch((e) => console.log(e));
        };
        this.deleteAppFromBundle = (appId) => {
            const apps = this.state.bundleApps
                ? this.state.bundleApps.filter((app) => app.webSolutionBase.id !== appId)
                : [];
            this.setState({ bundleApps: apps });
        };
        this.refetchApps = async () => {
            this.setState({
                isFetching: true,
            });
            const { newInstalledApps, embeddedScriptAppsStatus, bundleApps, freeTrialAppIds, benefitApps, } = await this.fetchApps();
            this.setState({
                benefitApps,
                isFetching: false,
                newInstalledApps,
                embeddedScriptAppsStatus,
                bundleApps,
                freeTrialAppIds,
            });
        };
        this.state = {
            newInstalledApps: [],
            bundleApps: [],
            benefitApps: [],
            freeTrialAppIds: [],
            isFetching: true,
            embeddedScriptAppsStatus: {},
            msAppId: "22bef345-3c5b-4c18-b782-74d4085112ff",
            openModal: ModalNames.NONE,
        };
    }
    convertEmbeddedScriptAppsStatus(apps) {
        const initialValue = {};
        return apps?.reduce((obj, app) => {
            const appId = app?.appId;
            return {
                ...obj,
                [appId]: {
                    status: app?.status,
                    parameters: app?.parameters,
                },
            };
        }, initialValue);
    }
    async fetchEmbeddedScriptAppsStatusNew(apps) {
        const { baseUrl } = this.props;
        const statusAsArray = await getAllEmbeddedScriptAppsStatus(this.httpClient, baseUrl, apps);
        return this.convertEmbeddedScriptAppsStatus(statusAsArray);
    }
    async componentDidMount() {
        const { newInstalledApps, embeddedScriptAppsStatus, bundleApps, freeTrialAppIds, benefitApps, } = await this.fetchApps();
        const permissions = await getPermittedActions(this.props.baseUrl, this.props.metasiteId, this.httpClient);
        const siteData = await fetchSiteData(this.props.metasiteId, this.props.baseUrl, this.httpClient);
        this.setState({
            isFetching: false,
            newInstalledApps,
            freeTrialAppIds,
            embeddedScriptAppsStatus,
            permissions,
            siteIsPremium: siteData?.siteIsPremium,
            bundleApps,
            benefitApps,
        });
        this.props.onLoaded?.();
        sendOpenManageAppsBi(this.props.origin, this.props.metasiteId, this.props.editorType);
        const allApps = this.props.hideBusinessSolutions && this.props.deepLinkData
            ? await fetchInstalledApps(this.props.baseUrl, this.httpClient, this.props.locale, false)
            : newInstalledApps;
        const deepLinkState = getDeepLink(this.props.deepLinkData, allApps);
        if (deepLinkState && deepLinkState.modalProps) {
            this.openModal(deepLinkState.openModal, deepLinkState.modalProps);
        }
    }
    componentDidUpdate() {
        if (this.props.origin === Origin.BIZMGR) {
            ModuleRegistry.notifyListeners("app-market.pending-apps-count-changed");
        }
    }
    async handleEmbeddedScriptToggle(appDefId, newStatus, appInstanceId, embeddedScriptAppsStatus) {
        const msSignedInstance = this.props.getAppInstance(this.state.msAppId);
        if (msSignedInstance && appInstanceId) {
            return setEmbeddedScriptAppActive(newStatus, this.httpClient, appInstanceId, this.props.baseUrl, embeddedScriptAppsStatus[appDefId])
                .then((result) => {
                return {
                    status: result.data.properties.disabled
                        ? embeddedScriptAppStatus.DISABLED
                        : embeddedScriptAppStatus.ENABLED,
                    parameters: result.data.properties.parameters,
                };
            })
                .catch((e) => false);
        }
    }
    async fetchApps() {
        const { baseUrl, locale, hideBusinessSolutions, origin } = this.props;
        const geoString = "";
        const isDayfulFlow = origin === Origin.DAYFUL;
        let [installedApps, bundleApps, benefitApps, dayfulApps, freeTrialAppIds] = await Promise.all([
            fetchInstalledApps(baseUrl, this.httpClient, locale, hideBusinessSolutions),
            fetchBundleApps(baseUrl, this.httpClient, locale, geoString, this.props.experiments),
            getBenefitApps(this.httpClient, locale, this.props.experiments),
            isDayfulFlow
                ? fetchAppIdsByTag(baseUrl, this.httpClient, locale, "e5c806a3-7ef7-4d32-bdc1-bbe913d93d48")
                : [],
            getFreeTrialAppIds(this.httpClient),
        ]);
        if (origin === Origin.DAYFUL) {
            installedApps = installedApps.filter((installedApp) => {
                return dayfulApps.tagApps.some((tagApp) => tagApp.appId === installedApp.appId);
            });
        }
        const enrichedBundleApps = newEnrichBundleApps(bundleApps, installedApps);
        const enrichedBenefitApps = benefitApps.map((benefitApp) => enrichBenefitApp(benefitApp, installedApps));
        const embeddedScriptAppsStatus = await this.fetchEmbeddedScriptAppsStatusNew(installedApps);
        return {
            newInstalledApps: installedApps,
            embeddedScriptAppsStatus,
            benefitApps: enrichedBenefitApps,
            bundleApps: enrichedBundleApps,
            freeTrialAppIds,
        };
    }
    render() {
        if (this.state.isFetching) {
            return (React.createElement(WixDesignSystemProvider, { features: { newColorsBranding: true }, as: "span" },
                React.createElement(ModalsNew, { ...this.state.modalProps }),
                this.props.referralInfo === "marketing-integrations" && (React.createElement(MarketingIntegrationsToast, { navigateToMarketingIntegration: this.props.navigateToMarketingIntegration })),
                React.createElement("div", { className: s.loaderWrapper },
                    React.createElement(Loader, { size: "medium" }))));
        }
        const completeSetupAppsCandidates = getCompleteSetupApps(this.state.newInstalledApps, this.state.bundleApps, this.state.siteIsPremium, this.props.experiments, origin === Origin.DAYFUL, this.state.benefitApps);
        const completeSetupApps = this.props.isEditorless
            ? []
            : completeSetupAppsCandidates;
        const checkPicassoManageAppsEnabled = this.props.experiments.enabled('specs.dcc.checkPicassoManageApps');
        const regularApps = (this.props.isEditorless && !checkPicassoManageAppsEnabled
            ? // treat all pending installations apps as installed when there is no editor
                completeSetupAppsCandidates.map((app) => ({
                    ...app,
                    installationDetails: {
                        ...app.installationDetails,
                        group: AppGroup.INSTALLED,
                    },
                }))
            : []).concat(this.state.newInstalledApps?.filter((app) => isRegularApp(app) &&
            completeSetupApps.findIndex((completeSetupApp) => completeSetupApp.appId === app.appId) === -1));
        const businessApps = this.state.newInstalledApps?.filter((app) => isBusinessApp(app) &&
            completeSetupApps.findIndex((completeSetupApp) => completeSetupApp.appId === app.appId) === -1);
        const authorizationHeader = this.props.getAppInstance
            ? this.props.getAppInstance(this.state.msAppId)
            : "";
        const { experiments } = this.props;
        const { bundleApps, benefitApps } = this.state;
        return (React.createElement(WixDesignSystemProvider, { features: { newColorsBranding: true }, as: "span" },
            React.createElement(ModalsNew, { ...this.state.modalProps }),
            this.props.referralInfo === "marketing-integrations" && (React.createElement(MarketingIntegrationsToast, { navigateToMarketingIntegration: this.props.navigateToMarketingIntegration })),
            this.state.newInstalledApps?.length > 0 || bundleApps?.length > 0 ? (React.createElement(Page, null,
                React.createElement(Page.Header, { dataHook: "manage-apps-page-header", title: this.props.t("manage-apps.page.title"), subtitle: this.props.origin === Origin.DAYFUL
                        ? this.props.t("manage-apps.page.dayful-subtitle")
                        : this.props.t("manage-apps.page.subtitle"), actionsBar: this.props.isEditorless ? null : (React.createElement(Button, { priority: "secondary", onClick: () => {
                            sendAddAppBi(this.props.origin, this.props.metasiteId, this.props.editorType);
                            this.props.goToHomePage();
                        }, dataHook: "manage-apps-go-to-app-market" }, this.props.t(this.props.isEditorless
                        ? "manage-apps.business-apps.editorless-card-header.title"
                        : "manage-apps.get-more-apps"))) }),
                React.createElement(Page.Content, null,
                    React.createElement(AppMarketSaleBanner, { i18n: this.props.i18n, goToHomePage: this.props.goToHomePage, msid: this.props.metasiteId, origin: this.props.origin }),
                    React.createElement(Box, { paddingBottom: 4 }),
                    React.createElement(PermissionsCtx.Provider, { value: this.state.permissions },
                        React.createElement(AppsSection, { isEditorless: this.props.isEditorless, apps: completeSetupApps, freeTrialAppIds: this.state.freeTrialAppIds, bundleApps: bundleApps, benefitApps: benefitApps, origin: this.props.origin, msid: this.props.metasiteId, experiments: experiments, mainButtonAction: (app) => {
                                const appHasBlocks = Boolean(getBuilderComps(app)?.length);
                                if (this.props.origin === Origin.BIZMGR &&
                                    appHasBlocks &&
                                    isNewVersionAvailable(app)) {
                                    this.openModal(ModalNames.UPDATE, { app });
                                }
                                else {
                                    this.props.mainButtonAction(app, bundleApps, benefitApps, this.refetchApps);
                                }
                            }, getAppInstance: this.props.getAppInstance, openModal: this.openModal, baseUrl: this.props.baseUrl, 
                            // @ts-expect-error
                            deleteApp: this.deleteAppAndUpdatePage, isBusinessApp: false, editorType: this.props.editorType, 
                            // @ts-expect-error
                            gotoWebSolutionPage: this.props.gotoWebSolutionPage, updateEmbeddedScriptAppsStatus: this.updateEmbeddedScriptAppsStatus, embeddedScriptAppsStatus: this.state.embeddedScriptAppsStatus, siteIsPremium: this.state.siteIsPremium, isActionRequiredSection: true, openApp: this.props.openApp, deleteAppFromBundle: this.deleteAppFromBundle, siteIsBusinessFirstSite: this.props.siteIsBusinessFirstSite, dataHook: "pendingSection", locale: this.props.locale, i18n: this.props.i18n, showUserActionNotification: this.props.showUserActionNotification, editorUrl: this.props.editorUrl, openDeleteModalAppInEditor: this.props.openDeleteModalAppInEditor },
                            React.createElement(CompleteSetupHeader, { badgeCounter: completeSetupApps?.length })),
                        React.createElement(AppsSection, { isEditorless: this.props.isEditorless, experiments: experiments, apps: regularApps, freeTrialAppIds: this.state.freeTrialAppIds, bundleApps: bundleApps, benefitApps: benefitApps, origin: this.props.origin, msid: this.props.metasiteId, mainButtonAction: (app // here
                            ) => this.props.mainButtonAction(app, bundleApps, benefitApps, this.refetchApps), addAppAgain: this.props.addAppAgain, getAppInstance: this.props.getAppInstance, updateEmbeddedScriptAppsStatus: this.updateEmbeddedScriptAppsStatus, embeddedScriptAppsStatus: this.state.embeddedScriptAppsStatus, openModal: this.openModal, baseUrl: this.props.baseUrl, 
                            // @ts-expect-error
                            deleteApp: this.deleteAppAndUpdatePage, isBusinessApp: false, editorType: this.props.editorType, 
                            // @ts-expect-error
                            gotoWebSolutionPage: this.props.gotoWebSolutionPage, siteIsPremium: this.state.siteIsPremium, dataHook: "installedSection", locale: this.props.locale, i18n: this.props.i18n, authorizationHeader: authorizationHeader, showUserActionNotification: this.props.showUserActionNotification, editorUrl: this.props.editorUrl, openDeleteModalAppInEditor: this.props.openDeleteModalAppInEditor },
                            React.createElement(RegularHeader, null)),
                        this.props.origin !== Origin.DAYFUL ? (React.createElement(React.Fragment, null,
                            React.createElement(AppsSection, { isEditorless: this.props.isEditorless, apps: businessApps, experiments: experiments, freeTrialAppIds: this.state.freeTrialAppIds, bundleApps: bundleApps, benefitApps: benefitApps, origin: this.props.origin, msid: this.props.metasiteId, mainButtonAction: (app) => this.props.mainButtonAction(app, bundleApps, benefitApps, this.refetchApps), addAppAgain: this.props.addAppAgain, getAppInstance: this.props.getAppInstance, openModal: this.openModal, baseUrl: this.props.baseUrl, 
                                // @ts-expect-error
                                deleteApp: this.deleteAppAndUpdatePage, isBusinessApp: true, editorType: this.props.editorType, 
                                // @ts-expect-error
                                gotoWebSolutionPage: this.props.gotoWebSolutionPage, siteIsPremium: this.state.siteIsPremium, dataHook: "businessSolutionsSection", locale: this.props.locale, i18n: this.props.i18n, showUserActionNotification: this.props.showUserActionNotification, editorUrl: this.props.editorUrl, openDeleteModalAppInEditor: this.props.openDeleteModalAppInEditor },
                                React.createElement(BusinessHeader, null)),
                            !this.props.isEditorless && (React.createElement(React.Fragment, null,
                                React.createElement(Box, { align: "space-between", verticalAlign: "middle", marginTop: "48px", marginBottom: "18px" },
                                    React.createElement(Heading, { dataHook: "recommended-apps-section-title", appearance: "H3" }, this.props.t("manage-apps.recommended-for-you")),
                                    React.createElement(TextButton, { suffixIcon: React.createElement(ChevronRight, null), onClick: () => {
                                            sendAddAppBi(this.props.origin, this.props.metasiteId, this.props.editorType);
                                            this.props.goToHomePage();
                                        } }, this.props.t("manage-apps.see-all-apps"))),
                                React.createElement("div", { style: { marginBottom: "12px" } },
                                    React.createElement(Divider, null)),
                                React.createElement(RecommendedApps, { baseUrl: this.props.baseUrl, httpClient: this.httpClient, locale: this.props.locale, origin: this.props.origin, gotoWebSolutionPage: this.props.gotoWebSolutionPage, editorType: this.props.editorType, msid: this.props.metasiteId }))))) : null)))) : (React.createElement(EmptyState, { isEditorless: this.props.isEditorless, isPicasso: this.props.isPicasso, baseUrl: this.props.baseUrl, msid: this.props.metasiteId, locale: this.props.locale, 
                // @ts-expect-error
                gotoWebSolutionPage: this.props.gotoWebSolutionPage, goToHomePage: this.props.goToHomePage, origin: this.props.origin, editorType: this.props.editorType, httpClient: this.httpClient }))));
    }
};
ManageInstalledAppsPage = __decorate([
    withTranslation,
    withExperiments
], ManageInstalledAppsPage);
export { ManageInstalledAppsPage };
function sendAddAppBi(origin, msid, editorType) {
    const biLogger = webBiLogger.factory().logger();
    biLogger
        .report(manageAppsAddApp({
        market: origin === Origin.BIZMGR
            ? editorType === EditorType.ADI
                ? "adi_dashboard"
                : "dashboard"
            : origin,
        msid,
        referral_info: "manage_apps",
    }))
        .catch((e) => console.log(e));
}
function sendOpenManageAppsBi(origin, msid, editorType) {
    const biLogger = webBiLogger.factory().logger();
    biLogger
        .report(appMarketOpenManageApps({
        msid,
        market: origin === Origin.BIZMGR
            ? editorType === EditorType.ADI
                ? "adi_dashboard"
                : "dashboard"
            : origin,
    }))
        .catch((e) => console.log(e));
}
//# sourceMappingURL=manage-installed-apps-page.js.map